import getMeta from '../router/meta-info';

// 全局混入metaInfo具体见vue-meta-info插件
export default {
    metaInfo(){
        return getMeta(this);
    }
}